import { render } from "./TheZoneDetails.vue?vue&type=template&id=d7dc8844"
import script from "./TheZoneDetails.vue?vue&type=script&lang=js"
export * from "./TheZoneDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__